<template>
  <div class="g-photo-wrap">
    <img alt="" v-src="{
        url,
        defaultUrl
    }" class="g-photo">
    <div class="g-upload">
      <input type="file" 
        accept="image/jpeg,image/jpg,/image/png" 
        class="g-upload-input"
        ref="file"
        @change="$emit('change',$event,$el)"
      >
      <a><img :src="require('@img/upload.png')" alt="" class="icon"></a>
      <p>{{ label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VPhoto',
  props: {
    url: '',
    defaultUrl: require('@img/default-img.png'),
    label: [String]
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var.scss";
.g-photo-wrap {
  background: $color-bg;
  text-align: center;
  height: 146px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 300px;
  margin: auto;
  overflow: hidden;
  .g-photo {
    position: absolute;
    z-index: 1;
    width: 100%;
  }
  .g-upload {
    position: relative;
    z-index: 3;
    color: #666666;
    .icon {
      width: 74px;
    }
    .g-upload-input {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      top: 0;
      left: 0;
      transform: translateZ(0)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/base/photo.vue